﻿'use strict';

angular.module('ntmApp').factory('UnAssignedActivitiesFilter', ['SimpleFilter', 'MultiSelectFilter', 'TimeFilter',
    function (SimpleFilter, MultiSelectFilter, TimeFilter) {

    function UnAssignedActivitiesFilter() {

        var self = this;

        self.RoomTypeFilter = new MultiSelectFilter();
        self.SpeciesFilter = new MultiSelectFilter();
        self.RoomFilter = new MultiSelectFilter();
        self.RecurrenceFilter = new MultiSelectFilter();
        self.ActivityFilter = new MultiSelectFilter();
        self.DurationFilter = new TimeFilter('Duration {0} {1}h {2}m');
        self.OriginalStaffFilter = new SimpleFilter();

        self.getfilters = function () {
            return [
                self.RoomTypeFilter,
                self.OriginalStaffFilter,
                self.SpeciesFilter,
                self.RoomFilter,
                self.RecurrenceFilter,
                self.ActivityFilter,
                self.DurationFilter
            ];
        };
        self.getAppliedFilters = function () {
            return self.getfilters().filter(function (filter) {
                return filter.isDefined();
            });
        };

        self.applied = function () {
            var filters = self.getAppliedFilters();

            if (filters) {
                return filters.length > 0;
            }

            return false;
        };

        self.isPartlyDefined = function () {
            return self.getfilters().some(function(filter) { return filter.isPartlyDefined(); });
        };

        self.clearAllFilters = function () {
            self.getfilters().forEach(function (filter) {
                filter.clear();
            });
        };

        self.filterActivities = function (items) {

            var result = [];

            if (items) {

                items.forEach(function (item) {

                    if (self.RoomTypeFilter.isDefined() && !self.RoomTypeFilter.selectedItems.some(function (roomType) {
                        return roomType.id === item.roomTypeId;
                    })) {
                        return;
                    }

                    if (self.SpeciesFilter.isDefined() && !self.SpeciesFilter.selectedItems.some(function (species) {
                        return species.id === item.speciesId;
                    })) {
                        return;
                    }

                    if (self.RoomFilter.isDefined() && !self.RoomFilter.selectedItems.some(function (room) {
                        return room.id === item.roomNumber;
                    })) {
                        return;
                    }

                    if (self.RecurrenceFilter.isDefined() && !self.RecurrenceFilter.selectedItems.some(function (recurr) {
                        return recurr.id === item.recurrId;
                    })) {
                        return;
                    }

                    if (self.ActivityFilter.isDefined() && !self.ActivityFilter.selectedItems.some(function (activity) {
                        return activity.id === item.activityId;
                    })) {
                        return;
                    }

                    if (self.OriginalStaffFilter.isDefined() && self.OriginalStaffFilter.filterItem.id !== item.originalStaffId) {
                        return;
                    }

                    if (self.DurationFilter.isDefined()) {

                        var filterMinutes = parseFloat(self.DurationFilter.hours) * 60 + parseFloat(self.DurationFilter.minutes);
                        var itemDuration = parseFloat(item.duration);

                        var isDurationFilterApplied = self.DurationFilter.comparator === '>=' ? itemDuration >= filterMinutes : itemDuration <= filterMinutes;

                        if (!isDurationFilterApplied) {
                            return;
                        }
                    }

                    result.push(item);
                });
            }

            return result;
        };
    }

    return (UnAssignedActivitiesFilter);
}]);